import { RUNNING_ANTARDASHA_CARD_COPY } from "./running-antardasha-card-copy";

/**
 * The Hindi antardasha check's form props, shared by the server-rendered shell
 * (RunningAntardashaCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the
 * island loads reads the same words. Like the planet-page check: no name field,
 * and the birth time is required, because dasha dates follow the Moon's exact
 * position at birth.
 */
export const RUNNING_ANTARDASHA_FORM = {
  language: "hi",
  submitLabel: RUNNING_ANTARDASHA_CARD_COPY.submit,
  timeRequiredHint: RUNNING_ANTARDASHA_CARD_COPY.timeRequiredHint,
  collectName: false,
  requireBirthTime: true,
} as const;

// One slot convention for both dasha checks: the same box that every state
// fills, BirthDetailsForm's "-default" input ids, and the placement that
// free_tool_started and calculator_used record (source_path tells the pages
// apart).
export {
  RUNNING_DASHA_FIELD_IDS as RUNNING_ANTARDASHA_FIELD_IDS,
  RUNNING_DASHA_FRAME as RUNNING_ANTARDASHA_FRAME,
  RUNNING_DASHA_PLACEMENT as RUNNING_ANTARDASHA_PLACEMENT,
} from "./running-dasha-form";
